var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.697,
    height: 16.379,
    viewBox: "0 0 15.697 16.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_9_",
    "data-name": "svgexport-6 (9)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23000",
    "data-name": "Path 23000",
    d: "M133.46,344.062a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,133.46,344.062Zm0,0",
    transform: "translate(-123.905 -330.412)",
    fill: "#ffa000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23001",
    "data-name": "Path 23001",
    d: "M11.607,49.439a4.766,4.766,0,0,1-3.7-6.641,4.761,4.761,0,0,0-5.864,4.648v1.9a4.576,4.576,0,0,1-1.63,3.5,1.194,1.194,0,0,0,.777,2.1H12.455a1.194,1.194,0,0,0,.77-2.108A4.57,4.57,0,0,1,11.607,49.439Zm0,0",
    transform: "translate(0 -41.303)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23002",
    "data-name": "Path 23002",
    d: "M284.157,3.412A3.412,3.412,0,1,1,280.744,0,3.412,3.412,0,0,1,284.157,3.412Zm0,0",
    transform: "translate(-268.46)",
    fill: "#f44336"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.2a2c1fe455bd3c29c0f092a31e770e6f.svg";
export { ForwardRef as ReactComponent };